import { ApiResult, HttpClient } from "../http.js";
import { LeaveType } from "../types/leave.js";
import { UserPayDto } from "../types/user-pay.js";

/**
 * One row of the PUT payload. Exactly one of `timeTypeId`/`leaveType` must be
 * set — the API rejects both-or-neither. Rows omitted from the array are left
 * untouched server-side.
 */
export interface UserPayRowInput {
  timeTypeId?: string | null;
  leaveType?: LeaveType | string | null;
  costPrice: number | null;
  employeeSelectable: boolean;
  adminSelectable: boolean;
}

export interface UpdateUserPayPayload {
  rows: UserPayRowInput[];
}

/**
 * `/api/users/{userId}/pay` — the Løn tab. Both verbs are gated on
 * Settings.ManageMembers server-side.
 */
export class UserPayApi {
  constructor(private readonly http: HttpClient) {}

  /** GET /api/users/{userId}/pay */
  get(userId: string): Promise<ApiResult<UserPayDto>> {
    return this.http.get<UserPayDto>(`/api/users/${encodeURIComponent(userId)}/pay`);
  }

  /** PUT /api/users/{userId}/pay — replaces the given rows, returns the refreshed grid. */
  update(userId: string, payload: UpdateUserPayPayload): Promise<ApiResult<UserPayDto>> {
    return this.http.put<UserPayDto>(`/api/users/${encodeURIComponent(userId)}/pay`, {
      body: payload,
    });
  }
}
